export default "__VITE_ASSET__6uOnLnTq__"